import { defineComponent as _defineComponent } from 'vue';
import { faPlay, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton } from "bootstrap-vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ButtonSpinner',
    props: {
        title: { default: "" },
        wait: { type: Boolean, default: false },
        tooltip: { default: "" },
        disabled: { type: Boolean, default: false },
        size: { default: "md" },
        variant: { default: "primary" },
        icon: { default: undefined }
    },
    setup(__props) {
        return { __sfc: true, faPlay, faSpinner, FontAwesomeIcon, BButton };
    }
});
